var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("datepicker", {
    staticClass: "custom-date-picker",
    attrs: {
      "open-date": _vm.openDate,
      disabledDates: _vm.disabledDates,
      language: _vm.it,
      placeholder: _vm.placeholder,
      value: _vm.value,
      format: _vm.dateFormatter
    },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a35ab3d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a35ab3d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CustomDatePicker.vue
// module id = null
// module chunks = 